import React from 'react';
import './CrossPlatformAppDevelopment.css';
import { Helmet } from "react-helmet-async";
const features = [
    "Single Codebase for iOS & Android",
    "Flutter & React Native Development",
    "Native Performance & UI Consistency",
    "Faster Development Cycles",
    "Hot Reload for Instant Changes",
    "API Integration & Firebase Support",
    "Modular Architecture",
    "Support for Wearables & Tablets"
];

const benefits = [
    "Reduced Development Cost",
    "Faster Time to Market",
    "Consistent UX Across Devices",
    "Easy Maintenance & Updates",
    "Wide Developer Community",
    "App Store & Play Store Deployment",
    "Smooth Third-Party Integration",
    "Better ROI for MVPs & Startups"
];

const industries = [
    "Healthcare",
    "E-Commerce",
    "Finance & Fintech",
    "EdTech",
    "Travel & Booking",
    "On-Demand Services",
    "Fitness & Lifestyle",
    "Media & Content Streaming"
];

const CrossPlatformAppDevelopment = () => {
    return (
        <div className="cross-container">


          <Helmet>
  <title>Cross-Platform App Development | APTech Solution Ankleshwar</title>
  <meta 
    name="description" 
    content="APTech Solution offers expert cross-platform mobile app development for iOS and Android using Flutter, React Native, and Xamarin. Build apps faster and cost-efficiently." 
  />
  
</Helmet>


            <h1 className="cross-title">Cross-Platform App Development</h1>
            <p className="cross-subtitle">
                Build apps faster and smarter — one codebase, multiple platforms. We specialize in Flutter and React Native solutions that feel truly native.
            </p>

            <section className="cross-section">
                <h2 className="section-heading">Why Choose Cross-Platform?</h2>
                <p className="cross-paragraph">
                    Cross-platform frameworks like Flutter and React Native allow businesses to launch mobile apps on iOS and Android simultaneously. Save time, cut costs, and ensure consistent user experience across devices.
                </p>
            </section>

            <section className="cross-section">
                <h2 className="section-heading">Core Features</h2>
                <div className="card-grid">
                    {features.map((feature, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🔁</span>
                            <p>{feature}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cross-section">
                <h2 className="section-heading">Industries We Serve</h2>
                <div className="card-grid">
                    {industries.map((industry, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🌐</span>
                            <p>{industry}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cross-section">
                <h2 className="section-heading">Benefits of Cross-Platform Apps</h2>
                <div className="card-grid">
                    {benefits.map((benefit, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🚀</span>
                            <p>{benefit}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cta-box">
                <h3>Start Building Cross-Platform</h3>
                <p>From MVPs to enterprise apps — we help you launch faster with Flutter and React Native solutions.</p>
                <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Start Your Project</button>
                    </a>
               
            </section>
        </div>
    );
};

export default CrossPlatformAppDevelopment;
